<template>
  <div>
    <div class="home-page">
      <div class="bg"></div>
      <div class="content">
        <div class="flex">
          <div class="icon">
            <img src="./../../assets/home/icon.png" alt="" />
          </div>
          <div>
            每位选手会随机获得两张玻片，每张玻片设置4个问题，涉及“低倍镜操作考核”、“高倍镜下结果判读”。总共8道题，满分100分。
          </div>
        </div>
        <div class="flex">
          <div class="icon">
            <img src="./../../assets/home/icon.png" alt="" />
          </div>
          <div>“低倍镜操作考核”包含1道选择题，首次选对计20分，否则不算分。</div>
        </div>
        <div class="flex">
          <div class="icon">
            <img src="./../../assets/home/icon.png" alt="" />
          </div>
          <div>“高倍镜下结果判读”包含3道选择题，每题10分。</div>
        </div>
        <div @click="handleGoBack" class="btn">返 回</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isErrorShow: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path; //获取上一级路由的路径
    });
  },
  created() {},
  mounted() {},

  methods: {
    // 返回上一步
    handleGoBack() {
      // this.$router.replace(this.fromPath)
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
.home-page {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/cbbj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .bg {
    height: 90px;
  }
  .content {
    width: 653px;
    height: 881px;
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border: 2px solid #ffffff;
    border-radius: 60px;
    margin: 0 auto;
    padding-top: 120px;
    .flex {
      display: flex;
      padding: 0 60px 50px 60px;
      .icon {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        margin-right: 24px;
        img {
          width: 16px;
          height: 16px;
        }
      }
      font-size: 25px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #4c4c4c;
      line-height: 50px;
    }
    .btn {
      width: 303px;
      height: 69px;
      background: linear-gradient(90deg, #1e3c72, #2a5298);
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      border-radius: 34px;
      margin: 0 auto;
      text-align: center;
      line-height: 69px;
      font-size: 36px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #ffffff;
      margin-top: 160px;
    }
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(255, 255, 255, 0.8);
}
.dialog {
  width: 612px;
  height: 580px;
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
  border-radius: 60px;
  .title {
    font-size: 65px;
    font-family: HarmonyOS Sans SC;
    font-weight: bold;
    color: #ab3b91;
    text-align: center;
    margin-top: 100px;
  }
  .text {
    font-size: 35px;
    font-family: HarmonyOS Sans SC;
    font-weight: bold;
    color: #333333;
    line-height: 60px;
    margin-top: 80px;
    text-align: center;
  }
  .flex {
    display: flex;
    margin: 0 50px;
  }
  .footer-modl {
    width: 200px;
    margin: 0 auto;
    height: 79px;
    background: linear-gradient(90deg, #1e3c72, #2a5298);
    border: 1px solid #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
    text-align: center;
    font-size: 35px;
    font-family: HarmonyOS Sans SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 79px;
    letter-spacing: 2px;
    border-radius: 40px;
    margin-top: 100px;
  }
}
</style>
